import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsurance = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#a4bde9",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.93358 2.97481V7.71222C1.93359 9.20962 2.38736 10.6719 3.23506 11.9062C4.08277 13.1406 5.28462 14.0891 6.68218 14.6267L7.32989 14.8756C7.76123 15.0415 8.23877 15.0415 8.6701 14.8756L9.31781 14.6267C10.7154 14.0891 11.9172 13.1406 12.7649 11.9062C13.6126 10.6719 14.0664 9.20962 14.0664 7.71222V2.97481C14.0677 2.79652 14.0174 2.62167 13.9216 2.47132C13.8257 2.32097 13.6885 2.20152 13.5263 2.12738C11.7841 1.36692 9.9009 0.982948 8 1.00058C6.0991 0.982948 4.2159 1.36692 2.47365 2.12738C2.3115 2.20152 2.17425 2.32097 2.07843 2.47132C1.98261 2.62167 1.93231 2.79652 1.93358 2.97481Z",
		fill: "currentColor",
		fillOpacity: .25,
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.84174 7.8237L7.29241 9.27448L10.5676 5.99927",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgInsurance;
